import classNames from 'classnames';
import React from 'react';

import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {
    CardDescription,
    CardTitle as CardTitleComponent,
} from '@udemy/react-product-card-components';

import styles from './card-helpers.module.less';

export const GoogleCourseCardAuthors = (): JSX.Element => {
    const {gettext, interpolate} = useI18n();

    return (
        <CardDescription>
            <LocalizedHtml
                className={classNames(styles['course-authors'], 'ud-text-xs')}
                html={interpolate(
                    gettext('<span class="brandLogo"></span> %(createdBy)s %(brandName)s'),
                    {createdBy: gettext('Created by'), brandName: 'Google'},
                    true,
                )}
                interpolate={{
                    brandLogo: <Icon glyph="google" label="Google" size="xxsmall" />,
                }}
            />
        </CardDescription>
    );
};

export const CardTitle = ({title, href}: {title: string; href?: string}): JSX.Element => (
    <CardTitleComponent
        headingLevel="h4"
        {...(href ? {renderLink: CardTitleComponent.renderAnchorTag({href})} : {})}
    >
        <span className={styles['card-title']}>{title}</span>
    </CardTitleComponent>
);
